<template>
	<div>
		<DialogBody class="mt-6">
			<Cover class="rounded-4" width="100%" height="211px" :src="image" />
			<h3 class="text-neutral-950 text-heading-xl mt-4">{{ title }}</h3>
			<p class="text-neutral-800 text-body-m mt-2" v-html="description"></p>
			<ul v-if="bulletList?.length" class="px-6">
				<li
					v-for="(bullet, i) in bulletList"
					:key="`bullet-item-${i}`"
					class="text-neutral-800 text-body-m"
				>
					{{ bullet }}
				</li>
			</ul>
		</DialogBody>
		<DialogActions
			:accept-action="{ text: acceptText }"
			:cancel-action="cancelText ? { text: cancelText } : undefined"
			:vertical-actions="isXS"
			@accept="accept"
			@cancel="$emit('cancel')"
		/>
	</div>
</template>
<script setup lang="ts">
	export interface Props {
		title: string
		description: string
		image: string
		acceptText: string
		isXS: boolean
		cancelText?: string
		bulletList?: string[]
		acceptAction?: () => void
	}
	const props = defineProps<Props>()
	const emit = defineEmits(['accept', 'cancel'])

	const accept = () => {
		setTimeout(() => {
			if (!props.acceptAction) return
			props.acceptAction()
		}, 150)
		emit('accept')
	}
</script>
